// extracted by mini-css-extract-plugin
export default {"button":"NotifyButton_button__5KWJ3"};